import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const Dropdown = ({
  options,
  name,
  icon,
  className,
  assetId,
  direction,
  onOptionSelect,
  returnFullObject = false,
  truncateText,
  size,
  disabled,
  iconColor = "text-dark dark:text-white",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setHoveredOption(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeDropdown);
    return () => {
      document.removeEventListener("mousedown", closeDropdown);
    };
  }, []);

  const getDropdownPosition = () => {
    switch (direction) {
      case "right":
        return "right-5";
      case "left":
        return "left-5";
      default:
        return "center-5";
    }
  };

  const handleOptionClick = (option, subOption) => {
    const selectedValue = subOption ? subOption : option;
    if (onOptionSelect) {
      onOptionSelect(returnFullObject ? selectedValue : selectedValue.name);
    }
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={className}
        disabled={disabled ? disabled : false}
      >
        {!icon &&
          (name
            ? truncateText
              ? truncateText(name, size)
              : name
            : "Dropdown")}
        {icon || (
          <FaChevronDown
            className={`w-3 h-3 ml-1 transform transition-transform ${iconColor} duration-700 ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
          />
        )}
      </button>

      {isOpen && (
        <div
          className={`absolute ${getDropdownPosition()} mt-2 w-40 rounded-md shadow-lg bg-[#e4e2ee] text-black ring-1 ring-black ring-opacity-5 z-10 
          ${
            options.some((option) => option.subOptions)
              ? ""
              : "overflow-y-auto max-h-60"
          }`}
        >
          <div className="py-1">
            {options && options.length > 0 ? (
              options.map((option, index) => (
                <div
                  key={index}
                  onMouseEnter={() => setHoveredOption(option)}
                  onMouseLeave={() => {
                    if (!option.subOptions) setHoveredOption(null);
                  }}
                >
                  {option.subOptions ? (
                    <div className="relative">
                      <div
                        className={`block w-full text-left px-4 py-2 text-sm flex justify-between items-center ${
                          hoveredOption === option
                            ? "bg-lightPrimary dark:bg-primary-gradient text-white"
                            : "hover:bg-lightPrimary hover:dark:bg-primary-gradient hover:text-black"
                        }`}
                      >
                        {option.name}{" "}
                        <FaChevronRight
                          className={`${
                            hoveredOption === option ? "rotate-0" : "rotate-180"
                          } inline ml-2 transform transition-transform duration-700`}
                        />
                      </div>
                      {hoveredOption === option && (
                        <div
                          className="absolute left-full top-0 mt-0 w-40 rounded-md shadow-lg bg-[#e4e2ee] text-black ring-1 ring-black ring-opacity-5 z-20 
                          overflow-y-auto max-h-60"
                          onMouseEnter={() => setHoveredOption(option)}
                          onMouseLeave={() => setHoveredOption(null)}
                        >
                          <div className="py-1">
                            {option.subOptions.map((subOption, subIndex) => (
                              <button
                                key={subIndex}
                                onClick={() =>
                                  handleOptionClick(option, subOption)
                                }
                                className="block w-full text-left px-4 py-2 text-sm text-black hover:bg-lightPrimary hover:text-white"
                              >
                                {subOption.name}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={() => handleOptionClick(option)}
                      className={`block w-full text-left px-4 py-2 text-sm break-words ${
                        !hoveredOption && assetId === option.id
                          ? "bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] dark:text-dark dark:button-primary-gradient"
                          : hoveredOption === option
                          ? "bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] text-white dark:button-primary-gradient"
                          : "hover:bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] hover:text-white hover:dark:button-primary-gradient"
                      }`}
                    >
                      {truncateText
                        ? truncateText(option.name, size)
                        : option.name}
                    </button>
                  )}
                </div>
              ))
            ) : (
              <div className="block w-full text-left px-4 py-2 text-sm text-gray-400">
                No options
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
